/* eslint-ignore */
// @ts-nocheck
import React, { useCallback, useState } from 'react';
import { Form, Formik } from 'formik';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { toast } from 'react-toastify';
import * as Yup from 'yup';

import TextField from 'components/layout/form/textField';
import {
  getSigninInfo,
  getUserAndPassword,
} from 'store/actions/signin-actions';
import theme from 'styles/theme';
import { handleUserId } from 'store/actions/user-actions';
import { useAuth } from 'hooks/authHook';

import {
  requestGetAccessToken,
  requestGetUserInfos,
  requestOauth,
} from 'services/authServices';

import { useMFAContext } from 'hooks/useMFA';
import {
  Button,
  ContainerWrapperForm,
  Field,
  Header,
  ContainerForm,
  FooterText,
  ContentLogo,
  Logo,
  Text,
  Title,
  LoginOptions,
  RememberMe,
  ForgotPassword,
  Footer,
  FooterContainer,
  PrivacyText,
} from './styles';

type AcessarGraneIProps = {
  setShowModalRestPass: React.Dispatch<React.SetStateAction<boolean>>;
};

const AcessarGranel: React.FC<AcessarGraneIProps> = ({
  setShowModalRestPass,
}) => {
  const [loading, setLoading] = useState();
  const [openAccordion, setOpenAccordion] = useState(false);
  const [haveToken] = useState(
    localStorage.getItem('@UltragazEmpresarial:accessToken')
  );
  const { signIn, setUserInfos } = useAuth();
  const history = useHistory();
  const dispatch = useDispatch();

  const {
    credentials: { token: lsMFAtoken },
    setCredentials,
    setUserId,
  } = useMFAContext();

  if (haveToken) {
    history.push('/portal');
  }

  const signinSchema = Yup.object().shape({
    password: Yup.string().required('Preencha sua senha'),
    username: Yup.string()
      .email('Insira um e-mail válido')
      .required('Preencha seu e-mail'),
  });

  const handleSelectAddress = useCallback(
    (
      customerSiteCode,
      customerSiteId,
      customerCode,
      customerId,
      customerName,
      addressLine,
      addressNumber,
      userCustomerRelationshipId,
      document
    ) => {
      setLoading(false);
      setUserInfos({
        customerSiteCode,
        customerSiteId,
        customerCode,
        customerId,
        customerName,
        customerAddressLine: `${addressLine}, ${addressNumber}`,
        userCustomerRelationshipId,
        document,
      });
    },
    [setLoading, history, setUserInfos]
  );

  const handleSubmit = useCallback(
    async ({ username, password }): void | Promise<any | void> => {
      setLoading(true);
      dispatch(getUserAndPassword(password));
      try {
        sessionStorage.setItem('@UltragazEmpresarial:X-Mfa-Login', username);
        setCredentials({ login: username, password, token: '' });

        const token = lsMFAtoken || null;

        const accessToken = await requestGetAccessToken();
        const responseOauth = await requestOauth(
          username,
          password,
          token,
          accessToken,
          dispatch,
          getSigninInfo
        );

        if (responseOauth) {
          signIn({
            loginEmail: username,
            accessToken: responseOauth.access_token,
            refreshToken: responseOauth.refresh_token,
            customerType: 'Granel',
          });
          requestGetUserInfos(
            username,
            responseOauth.access_token,
            dispatch,
            handleUserId,
            setUserInfos,
            handleSelectAddress,
            history
          );

          return true;
        }
        return false;
      } catch (error) {
        setLoading(false);
        const userId = error?.response?.data?.user?.id || null;
        const code = error?.response?.data?.code;
        const message = error?.response?.data?.message;
        const status = error?.response?.status;
        if (status && status === 401) {
          if (code === '401.004') {
            return setShowModalRestPass(true);
          }
          if (code === '401.006') {
            return toast.warn(message);
          }
          if (code === '401.007') {
            if (!userId) {
              toast.error('Usuário ou senha inválido!');
              return false;
            }
            toast.warn('Você precisa fazer uma verificação de duplo fator');
            localStorage.removeItem('@UltragazEmpresarial:X-Mfa-Hash');
            setUserId(userId);
            return history.push('/validar-token');
          }
        }
        if (message) {
          return toast.error(message);
        }
        toast.error('Ocorreu um erro interno na aplicação');
        return false;
      }
    },
    [
      dispatch,
      setCredentials,
      lsMFAtoken,
      signIn,
      setUserInfos,
      handleSelectAddress,
      history,
      setShowModalRestPass,
    ]
  );

  const isMobile = window.innerWidth <= 360;

  return (
    <>
      <ContentLogo>
        <Logo src="/static/ultragaz-logo-blue.svg" alt="Logo Ultragaz branca" />
      </ContentLogo>
      <ContainerWrapperForm>
        <Header onClick={() => setOpenAccordion(!openAccordion)} />
        <Text>Por favor, insira seus dados para acessar sua conta</Text>
        <ContainerForm openAccordion={openAccordion}>
          <Formik
            initialValues={{
              username: localStorage.getItem('rememberedEmail') || '',
              password: '',
              rememberMe: !!localStorage.getItem('rememberedEmail'),
            }}
            validationSchema={signinSchema}
            onSubmit={(values) => {
              if (values.rememberMe) {
                localStorage.setItem('rememberedEmail', values.username);
              } else {
                localStorage.removeItem('rememberedEmail');
              }
              handleSubmit(values);
            }}
            render={({
              handleChange,
              handleBlur,
              values,
              errors,
              touched,
              setFieldValue,
            }) => (
              <Form autoComplete="off">
                <Field>
                  <Title>E-mail</Title>
                  <TextField
                    id="username"
                    name="username"
                    borderHighlightColor={theme.colors.purple}
                    label="Inserir seu e-mail"
                    placeholder="Inserir seu e-mail"
                    type="email"
                    errorCondition={errors.username && touched.username}
                    errorMessage={errors.username}
                    isCorrect={!errors.username && !touched.username}
                    onBlur={handleBlur}
                    onChange={handleChange}
                    value={values.username}
                  />
                </Field>
                <Field>
                  <Title>Senha</Title>
                  <TextField
                    id="password"
                    name="password"
                    borderHighlightColor={theme.colors.purple}
                    label="Inserir senha"
                    placeholder="Inserir senha"
                    showChangeTextPassword="true"
                    type="password"
                    errorCondition={errors.password && touched.password}
                    errorMessage={errors.password}
                    onBlur={handleBlur}
                    onChange={handleChange}
                    value={values.password}
                  />
                </Field>
                <LoginOptions>
                  <RememberMe>
                    <input
                      type="checkbox"
                      id="rememberMe"
                      name="rememberMe"
                      checked={values.rememberMe}
                      onChange={(e) =>
                        setFieldValue('rememberMe', e.target.checked)}
                    />
                    Lembrar de mim
                  </RememberMe>
                  <ForgotPassword to="/esqueci-senha">
                    Esqueci minha senha
                  </ForgotPassword>
                </LoginOptions>
                <Button type="submit" loading={loading}>
                  Entrar
                </Button>
              </Form>
            )}
          />

          <FooterContainer>
            <Footer>
              <Title style={{ fontSize: isMobile && '13px' }}>
                Não possui uma conta?
              </Title>
              <a href="/novo-primeiro-acesso-granel">
                <FooterText>Cadastre-se agora</FooterText>
              </a>
            </Footer>
            <a
              href="https://www.ultragaz.com.br/institucional/politica-de-privacidade"
              target="_blank"
              rel="noreferrer"
            >
              <PrivacyText>Política de Privacidade</PrivacyText>
            </a>
          </FooterContainer>
        </ContainerForm>
      </ContainerWrapperForm>
    </>
  );
};

export default AcessarGranel;
